import React from 'react';
import { Container } from './style';
import LoginForm from '../../../containers/login';

const LoginView = props => (
  <Container>
    <LoginForm {...props} />
  </Container>
);

export default LoginView;



// WEBPACK FOOTER //
// ./src/components/views/login/index.js